/* eslint-disable no-underscore-dangle */
window._wq = window._wq || [];

export default function getWistiaVideoHandle(id, callback) {
  window._wq.push({
    id,
    onReady: callback,
  });
}
/* eslint-enable no-underscore-dangle */
